import { UserSearchFoundUserModel } from '@frontend/unhideschool/app/shared/models/user-search.model';

interface CourseItem {
  id: number;
  post: {
    title: string;
  };
}

export interface ICourseTrail {
  dateCreated: string;
  name: string;
  id: number;
  courses: {
    items: CourseItem[];
    totalCount: number;
  };
}

export interface ICareerUpdatePayload {
  workSpaceId: number;
  name: string;
  courseIds: number[];
  file: File;
  careerId?: number;
  mediaitemid: string;
}

export interface SpaceStateModel {
  careers: {
    courseTrail: ICourseTrail[];
    isLoading: boolean;
  };
  membersSearched: UserSearchFoundUserModel[];
  progressCareers: {
    id: number;
    progress: number;
  }[];
  progressCourses: {
    progress: number;
    post: {
      title: string;
      workspace: {
        name: string;
        id: number
      };
    };
  }[];
}

export const defaultMembershipState: SpaceStateModel = {
  careers: {
    courseTrail: [],
    isLoading: false,
  },
  membersSearched: [],
  progressCareers: [],
  progressCourses: [],
};
